import styled, { keyframes } from 'styled-components';

import { device } from '../HelperStyle';

export const LandingSectionContainer = styled.div`
  margin: 0 auto;
  height: calc(100vh - 60px);
  min-height: 500px;
`;

export const LandingSectionInfoContainer = styled.div`
  height: 375px;
  width: 375px;  
  margin-right: 30px;
  margin-left: 30px;
  text-align: center;
  
  @media ${device.tablet} {
    height: 80%;  
    width: 80%;
    margin: 0 auto;
  }

`;

export const LandingSectionInfoProfilePicture = styled.img`
  position: absolute;
  // make it show behind name
  left: 0; 
  right: 0; 
  margin-left: auto; 
  margin-right: auto; 

  z-index: -1;
  /* Post-splash only */
  height: 220px;
  width: 220px;
  /* sets pre-splash size */
  transform: scale(1.2);
  border-radius: 50%;
  object-fit: cover;

  @media ${device.mobileM} {
    height: 175px;  
    width: 175px;  
  }
`;

export const LandingSectionHeader = styled.div`
  font-size: 60px;
  margin: 0 auto;
  margin-top: 44px;
`;

export const LandingSectionPill = styled.div`
  /* initial opacity 0 for splash delay*/
  /* opacity: 0; */

  border-radius: 2px;
  width: 100%;
  height: 5px;
  background-color: white;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const LandingSectionTypistContainer = styled.div`
  /* initial opacity 0 for splash delay*/
  opacity: 0;
  
  font-size: 20px;
  margin-bottom: 20px;
`;

export const LandingSectionSocialLink = styled.a`
  text-decoration: none;
  margin-left: 10px;
  margin-right: 10px;
  color: inherit;
  @media ${device.tablet} {
    margin: 10px;
  }

`;
export const LandingSectionSocialIcon = styled.img`
  height: 40px;
  width: 40px;
  transition: 0.3s all ease-in-out;

  &:hover {
    transform: scale(1.2);
  }
`;

export const Bounce = keyframes`
  5%, 15%, 25%, 35%, 100%{
    transform: translate3d(0, 0, 0);
  }
  10%, 20%, 30% {
    transform: translate3d(0, -10px, 0) scale(1.01);
  }
`;

export const LandingSectionArrowContainer = styled.div`
  /* initial opacity 0 for splash delay*/
  opacity: 0;
  transition: 0.3s all ease-in-out;

  @media ${device.tablet}, ${`(max-height: 800px)`} {
    display: none;
  }
`;

export const LandingSectionMoreInfoArrow = styled.img`
  height: 75;
  width: 50;
  top: calc(100vh - 44px - 20px);
  cursor: pointer;

  position: absolute;
  left: calc(50% - 35px);
  animation: ${Bounce} 6s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
  animation-iteration-count:infinite;

`;

export const LandingSectionLinksContainer = styled.div`
  /* initial opacity 0 for splash delay*/
  /* opacity: 0; */

  @media ${device.tablet} {
    text-align: center;
  }
`;